function ErrorPage() {
    return (
        <h1>Upps... Nothing here</h1>
    );
}

export default ErrorPage;